import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from '../../components/common/Component';

export function ArticleEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["title"]} children={children} />
    );
}

export function ArticleCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"article"} children={children} />
    );
}
